<template>
    <AuthModal v-if="Object.keys(auth_modal).length" @close="auth_modal={}" :modal_data="auth_modal"
            @recovery_account="auth_modal={}" @close_and_login="login = true ; auth_modal={}" />

        <login v-else-if="login | is_interceptes" @close="login = false; closeLogin() " @openSingUp="login = false; sing_up=true"
            :sing_up="sing_up" @recovery_account="login = false; recovery_account=true"
            @loggedIn="userInfo()"
            :recovery_account="recovery_account" :login="login"></login>
        <SignUp v-else-if="sing_up" @close="sing_up = false" @openLogin="sing_up = false; login=true" :login="login"
            @login="text_modal = true; sing_up = false; auth_modal_data($event);" @email_sent="text_action='restore_account'; auth_modal_data($event);  sing_up = false" :sing_up="sing_up"></SignUp>
        <recovery-account v-else-if="recovery_account" @close="recovery_account = false; "
            @restore_account="text_action='restore_account'; auth_modal_data($event);  recovery_account = false"
            :recovery_account="recovery_account" />
        <new-password v-else-if="new_password" @close="new_password = false; login = true" :password_token="password_token"  @loggedIn="userInfo()" />
</template>


<script>
import { mapActions, mapState } from 'vuex';

import player from '@/clients/player';
import * as Cookies from 'js-cookie';
import login from '@/views/home-page-layouts/auth/login';
import SignUp from '@/views/home-page-layouts/auth/sing-up';
import RecoveryAccount from '@/views/home-page-layouts/auth/recovery-account.vue';
import NewPassword from '@/views/home-page-layouts/auth/new-password.vue';
import AuthModal from '@/views/home-page-layouts/auth/auth_modal.vue';
import getCookie from '@/mixins/getCookie';

export default {
  name: 'AuthorizationBase',

  mixins: [getCookie],

  props: ['is_login'],

  components: {
    login,
    SignUp,
    RecoveryAccount,
    NewPassword,
    AuthModal,
  },
  created() {
    this.login = this.is_login;
    this.userInfo();
  },
  mounted() {
    if (this.$route.params.auth) {
      this.password_token = this.$route.params.auth;
      this.new_password = true;
    }
    if (this.$route.params.team_id) {
      Cookies.set('invite_team_id', this.$route.params.team_id);
      Cookies.set('invite_token', this.$route.query.token);
      Cookies.set('invite_team_name', this.$route.query.name);
      this.user.id ? this.$router.push('/players/my-teams') : this.$router.push('/');
    }
    if (Cookies.get('invite_team_id')) {
      this.login = true;
    }
    if (this.$route.params.mail_auth) {
      const payload = this.$route.fullPath.slice(this.$route.fullPath.lastIndexOf('/') + 1);
      player.get(`/email/confirm/${payload}`)
        .then((data) => {
          this.auth_modal = {
            register_complete: true,
          };
          this.setToken(data.data.token)
            .then(() => {
              this.userInfo();
            });
        });
    }
    if (this.$route.query.code) {
      let location = window.location.pathname.length > 1 ? `${window.location.origin}${window.location.pathname}` : '';
      if (window.location.host.includes('local')) {
        location = window.location.pathname.length > 1 ? `https://portal.mozgo.com${window.location.pathname}` : '';
      }
      player.post(`/oauth/${this.$route.params.provider ? this.$route.params.provider : this.provider ? this.provider : ''}`, {
        code: this.$route.query.code,
        url: location,
        roistat_first_visit: this.getCookie('roistat_first_visit'),
        roistat_visit: window.roistat && window.roistat.visit ? window.roistat.visit : '',
        utm_source: this.getCookie('mozgoUtmSource'),
        utm_content: this.getCookie('mozgoUtmContent'),
        utm_medium: this.getCookie('mozgoUtmMedium'),
        utm_term: this.getCookie('mozgoUtmTerm'),
        utm_campaign: this.getCookie('mozgoUtmCampaign'),
      })
        .then((data) => {
          Cookies.remove('mozgoAuth', { domain: '.mozgo.com' });
          this.selectIsSocialNetwork(true);
          Cookies.set('mozgoAuth', data.data.token, { expires: 1, domain: '.mozgo.com' });
          this.setToken(data.data.token)
            .then(() => {
              this.userInfo();
              if (window.location.pathname.includes('vkontakte') ||
               window.location.pathname.includes('facebook') ||
               window.location.pathname.includes('google')) {
                this.$router.push('/');
              } else {
                this.$router.push(`${window.location.pathname}`);
              }
            });
        });
    }
  },
  data() {
    return {
      login: false,
      sing_up: false,
      recovery_account: false,
      new_password: false,
      auth_modal: {},
      password_token: '',
      logitn: '',
    };
  },
  computed: {
    ...mapState({
      provider: state => state.auth.provider,
      city_id: state => state.user.cityProps.id,
      is_fetched: state => state.auth.isDataFetched,
      is_interceptes: state => state.auth.interceptorsLogin,
      user: state => state.auth.user,
    }),
  },
  methods: {
    ...mapActions(['setToken', 'setUser']),
    ...mapActions(['selectIsSocialNetwork']),
    auth_modal_data(data) {
      this.auth_modal = data;
    },
    closeLogin() {
      this.$store.dispatch('updateInterceptorsLogin', false);
    },
    auth() {
      if (!this.login) this.login = !this.login;
      this.$emit('auth');
    },
    userInfo() {
      Cookies.get('invite_team_id') ? this.$router.push({ name: 'my-teams' }) : '';
      const route = this.city_id ? `/me?city_id=${this.city_id}` : '/me';
      if (this.is_fetched || !this.$store.state.auth.accessToken) return;
      player.get(route)
        .then(({
          data,
        }) => {
          if (data.date_of_new_eula > data.eula_accepted_at) {
            this.$emit('open_accept_update_modal');
          }
          if (data.role === 'partner' && (!data.is_approved || !data.is_main_approved)) {
            this.$emit('approve_modal');
          }
          this.setUser(data);
          this.login = false;
        });
    },
  },
  watch: {
    is_login() {
      this.login = this.is_login;
    },
  },
};
</script>
